import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'cierres',
})
export class CierresPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if (filter && items) {

      if (filter['id_local'] && filter['id_local'] > 0) {

        items = items.filter(function (item) {
          return item.id_local == filter['id_local'];
        });
      }

    }

    return items;

  }

}



// WEBPACK FOOTER //
// ./src/pipes/cierres/cierres.ts